import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        meta: {layout: 'main'},
        component: () => import('../views/Home.vue')
      },
      {
        path: '/education',
        name: 'Education',
        meta: {layout: 'main'},
        component: () => import('../views/Education.vue')
      },
      {
        path: '/training',
        name: 'Training',
        meta: {layout: 'main'},
        component: () => import('../views/Training.vue')
      },
      {
        path: '/training-category',
        name: 'TrainingCategory',
        meta: {layout: 'main'},
        component: () => import('../views/TrainingCategory.vue')
      },
      {
        path: '/achievement',
        name: 'Achievement',
        meta: {layout: 'main'},
        component: () => import('../views/Achievement.vue')
      },
      {
        path: '/experience',
        name: 'Experience',
        meta: {layout: 'main'},
        component: () => import('../views/Experience.vue')
      },
      {
        path: '/language-knowledge',
        name: 'Language-knowledge',
        meta: {layout: 'main'},
        component: () => import('../views/LanguageKnowledge.vue')
      },
      {
        path: '/createEducation',
        name: 'CreateEducation',
        meta: {layout: 'main'},
        component: () => import('../views/CreateEducation.vue')
      },
    ]
  },
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if(to.query.token && to.query.refresh_token) {
    store.dispatch('login', {'accessToken': to.query.token, 'refreshToken': to.query.refresh_token});
    next("/");
  }
  if(!store.getters.getAccessToken) {
    location.href = '/';
  }
  next();
});


export default router
